
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../App.css';
import './LoginPage.css';
import logo from '../../assets/img/logo-header.png';
import { validarLogin, validarSenha, validarCamposObrigatorios } from '../../utils/validators';
import { PermissaoLogin } from '../../services/authService';  


export default function LoginPage() {
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');

    const campos = { login, senha };
    const { valido, campo } = validarCamposObrigatorios(campos);
    if (!valido) {
      setErro(`O campo "${campo}" é obrigatório.`);
      return;
    }

    if (!validarLogin(login)) {
      setErro('Login inválido.');
      return;
    }

    if (!validarSenha(senha)) {
      setErro('Senha inválida.');
      return;
    }

    try {
      setCarregando(true);

      const data = await PermissaoLogin(login, senha);

      if (data && data.token) {
        navigate('/Agendamentos');
      } else {
        setErro('Dados Incorretos.');
      }
    } catch (error) {
      setErro(error.message || 'Erro ao tentar fazer login.');
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="login-container">

      <form className="login-form" onSubmit={handleSubmit}>
        <img src={logo} alt="Logotipo" />
        <h2>LOGIN</h2>

      <input className="login-inputs"
          type="text"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          placeholder="Login"
        />
        <input className="login-inputs"
          type="password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          placeholder="Senha"
        />

        <button type="submit" disabled={carregando}>
          {carregando ? 'Entrando...' : 'Entrar'}
        </button>

        {erro && <p className="erro-msg">
              Autenticação inválida<br/>
              Usuário ou senha incorretos<br/>
              {/*erro*/}
              </p>}


        <div className="login-footer">
          <Link to="/Cadastros" className="login-link">Não tem cadastro? Cadastre-se</Link>
          <Link to="/RecuperarSenha" className="login-link">Esqueci da Senha? Redefinir</Link>
          <Link to="/" className="login-link voltar">Voltar ao site</Link>
        </div>
      </form>
    </div>
  );
}
